import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import confirm from "../../shared/modal/confirm";
import ScrollIntoView from "../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../shared/loader";
import {
  addImageFiles,
  addImageUrl,
  clearRedirect,
  deleteBackgroundActor,
  deleteImageFile,
  deleteImageUrl,
  fetchBackgroundActor,
  mainImageUrlChanged,
  updateBackgroundActor,
  uploadImagesAndSaveActor
} from "./ducks/actions";
import Form from "./form";

function ActorsContainer(props) {
  const { filmId, actorId } = props.match.params;
  const {
    fetchBackgroundActor,
    fetchBackgroundActorSettings,
    updateBackgroundActor,
    deleteBackgroundActor,
    loadingActor,
    actor,
    errors,
    warnings,
    addImageFiles,
    addImageUrl,
    imageFiles,
    uploadImagesAndSaveActor,
    deleteImageUrl,
    deleteImageFile,
    mainImageUrlChanged,
    drinks,
    milkTypes,
    showFilmdUrl
  } = props;

  const invalidIds = ["add", "overview", "copy"];

  useEffect(() => {
    if (invalidIds.indexOf(actorId) === -1) {
      fetchBackgroundActor(filmId, actorId);
    }
  }, [filmId, actorId]);

  if (props.redirect) {
    if (props.redirect.to === "list") {
      props.clearRedirect();
      const url = `/films/${filmId}/background-actors/`;
      return <Redirect to={url} />;
    }
  }

  if (invalidIds.indexOf(actorId) > -1) {
    return null;
  }

  const onAddImagesFiles = (files) => {
    addImageFiles(files);
  };

  const onAddImagesUrl = (url) => {
    addImageUrl(url);
  };

  function renderLoading() {
    return <Loader />;
  }

  function renderActor(actor) {
    let dietaryRequirements: any[] = [];
    (props.dietaryRequirementEnum || []).forEach((item) => {
      if ((item.value & actor.dietaryRequirements) === item.value) {
        dietaryRequirements.push(item.value);
      }
    });

    actor.dietaryRequirementsArray = dietaryRequirements;
    return (
      <ScrollIntoView
        className="blade-content widest"
        path="/films/:filmId/background-actors/:actorId/edit"
        loading={loadingActor}>
        <Form
          errors={errors}
          warnings={warnings}
          mode="edit"
          filmId={filmId}
          actorId={actor.id}
          initialValues={actor}
          loading={loadingActor}
          onSubmit={onUpdateActor}
          handleDelete={onDeleteActor}
          onAddImageFiles={onAddImagesFiles}
          onAddImageUrl={onAddImagesUrl}
          onDeleteImageUrl={deleteImageUrl}
          onDeleteImageFile={deleteImageFile}
          imageFiles={imageFiles}
          mainImageUrl={actor.mainImageUrl}
          onMainImageUrlChanged={mainImageUrlChanged}
          drinks={drinks}
          milkTypes={milkTypes}
          showFilmdUrl={showFilmdUrl}
          {...props}
        />
      </ScrollIntoView>
    );
  }

  function onUpdateActor(actor) {
    sanitiseDataTypes(actor);

    const files = actor.pictures || [];

    if ((files && files.length) > 0 || (actor.images && actor.images.length > 0)) {
      uploadImagesAndSaveActor(actor, files, false, filmId);
    } else {
      updateBackgroundActor(filmId, actor);
    }
  }

  function onDeleteActor(actor) {
    confirm(() => deleteBackgroundActor(filmId, actor), actor?.firstName + " " + actor?.lastName);
  }

  function sanitiseDataTypes(actor) {
    actor.number = +actor.number;
    actor.gender = +actor.gender;
    actor.heightCentimeters = actor.heightCentimeters
      ? +actor.heightCentimeters
      : null;
    actor.weightKilograms = actor.weightKilograms
      ? +actor.weightKilograms
      : null;

    let dietaryRequirement = 0;
    actor.dietaryRequirementsArray.forEach((item) => {
      dietaryRequirement = dietaryRequirement | item;
    });

    actor.dietaryRequirements = dietaryRequirement;
    if (actor.ethnicityId === "") {
      actor.ethnicityId = null;
    }

    if (actor.skinColorId === "") {
      actor.skinColorId = null;
    }
  }

  return actor && !loadingActor ? renderActor(actor) : renderLoading();
}

function mapStateToProps(state) {
  const { backgroundActorsState, commonState } = state;
  return {
    actor: backgroundActorsState.actor,
    loadingActor: backgroundActorsState.loadingActor,
    errors: backgroundActorsState.errors,
    warnings: backgroundActorsState.warnings,
    showFilmdUrl: backgroundActorsState.showFilmdUrl,
    genderEnum: commonState.genderEnum,
    ethnicityEnum: commonState.ethnicityEnum,
    dietaryRequirementEnum: commonState.dietaryRequirementEnum,
    skinColors: commonState.skinColors,
    ethnicityTypes: commonState.ethnicityTypes,
    imageFiles: backgroundActorsState.imageFiles,
    redirect: backgroundActorsState.redirect,
    drinks: commonState.drinks,
    milkTypes: commonState.milkTypes
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchBackgroundActor,
    updateBackgroundActor,
    deleteBackgroundActor,
    addImageFiles,
    uploadImagesAndSaveActor,
    deleteImageUrl,
    deleteImageFile,
    mainImageUrlChanged,
    addImageUrl,
    clearRedirect
  })(ActorsContainer)
);
